@if (isPublicRoute) {
  <app-alert></app-alert>
  <router-outlet></router-outlet>
}
@else {
  @if (impersonation.state$().active) {
    <div class="impersonation-banner">
      <span>Currently impersonating {{ impersonation.state$().targetDisplayName || impersonation.state$().targetIdentityUserId }}</span>
      <button type="button" (click)="impersonation.stop()" [disabled]="impersonation.loading$()">Stop</button>
    </div>
  }
  @if (shouldShowOnboardingProgress) {
    <app-my-onboarding-progress [progress]="onboarding.status$()"></app-my-onboarding-progress>
  }
  <app-alert></app-alert>
  <router-outlet></router-outlet>
}
